import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { change_Lang } from "../../actions/Helper_action";
export const DynamicArticle = ({ bg_color, styles }) => {
  const dispatch = useDispatch();

  const name_krd = useSelector((state) => state.HelperReducer.name_krd);
  const name_en = useSelector((state) => state.HelperReducer.name_en);
  const name_arb = useSelector((state) => state.HelperReducer.name_arb);
  const lang = useSelector((state) => state.HelperReducer.lang);
  return (
    <>
      <tr style={{ background: `${bg_color}` }}>
        <td>13</td>
        <td style={styles}>{dispatch(change_Lang("balav_23"))}.</td>
      </tr>
      <tr>
        <td>14</td>
        <td style={styles}>
          {lang === "krd"
            ? `هەر یەک لە لایەنی یەکەم و لایەنی دووەم پێوستە بڕی کرێی نیو مانگ بۆ هەر ساڵێک بدەن بە ${name_krd} لە بڕی رێکخستنی ئەم گرێبەستە.`
            : lang === "arb"
            ? `على الطرفين دفع نصف مبلغ الأجرة سنوياً إلى ${name_arb} بدل تظيم هذا العقد`
            : `Each one of the first and the second party should pay half a month lease fee to ${name_en} for arranging this contract.`}
        </td>
      </tr>
      <tr style={{ background: `${bg_color}` }}>
        <td>15</td>
        <td style={styles}>{dispatch(change_Lang("balav_29"))}.</td>
      </tr>
      <tr>
        <td>16</td>
        <td style={styles}>
          {lang === "krd"
            ? `لەکاتی نوێ کردنەوەی گرێبەست هەر لایەنێک پابەند دەبێت بە پێدانی کرێی نیو مانگ بۆ یەک ساڵ بە ${name_krd}.`
            : lang === "arb"
            ? `يتعهد الطرفان عند تجديد العقد بدفع نصف مبلغ الأجرة سنوياً إلى ${name_arb}.`
            : `When renewing the contract each party will be committed to paying the amount of the lease fee for half a month to ${name_en} for each year.`}
        </td>
      </tr>
      <tr style={{ background: `${bg_color}` }}>
        <td>17</td>
        <td style={styles}>{dispatch(change_Lang("balav_32"))}.</td>
      </tr>
      <tr>
        <td>18</td>
        <td style={styles}>
          {lang === "krd"
            ? `لەکاتی چارەسەر نەبوونی کێشەی لایەنی یەکەم و دووەم بە شێوازی گفتوگۆ و دانوستاندن ئەوا ${name_krd} بەرپرس نیە و نابێت بەڵکو پێویستە لەسەر لایەنەکان کێشەکە چارەسەر بکەن بەگرتنەبەری رێکاری یاسایی و پەنابردن بۆ دادگای تایبەت.`
            : lang === "arb"
            ? `عند عدم حسم المشاكل بالحوار فيما بين الطرفين لا تتحمل ${name_arb} المسؤولية بل على الطرفين أن يحسم القضايا من خلال إجراءات قانونية واللجوء إلى محكمة خاصة. `
            : `In case of inability to solve the problem of the first and second parties through negotiations then ${name_en} is not responsible and will not be responsible but the parties should solve the problem through legal proceedings and to go to a specialized court.`}
        </td>
      </tr>
      <tr style={{ background: `${bg_color}` }}>
        <td>19</td>
        <td style={styles}>
          {lang === "krd" ? (
            <>
              {name_krd} بەرپرس نییە لە بوونی هەر کێشەیەک کە لەنێوان خاوەن مولک
              و کرێچی دا رووبدات .
            </>
          ) : lang === "arb" ? (
            <>
              {name_arb} غير مسؤول عن أي مشاكل أن يحدث بين مالك العقار
              والمستأجر.
            </>
          ) : (
            <>
              {name_en} is not responsible for any problems that occur between
              the two sides.
            </>
          )}
        </td>
      </tr>
    </>
  );
};

export const DynamicArticle_FirstPart = ({ bg_color, styles }) => {
  const lang = useSelector((state) => state.HelperReducer.lang);
  return (
    <>
      <tr>
        <td>8</td>
        <td style={styles}>
          {lang === "krd"
            ? `لايەنى دووەم بەلێن دەدات كه پارێزگارى له شوێنى بەكرێگیراو بكات له كاتى سوود وەرگرتن له شوێنەكە وە دوورى بگرێت له تێكجوون و داڕمان وه بەكارنەهێنانى به شێوەیەكى نەخوازراو`
            : lang === "arb"
            ? `يتعهد الطرف الثاني بحماية العقار المستأجَر عن الاستفادة منه والحفاظ عليه من التلف والهدم وعدم استخدامه على شكل غير مرغوب فيه.`
            : `The second party promises that it will protect the leased property when using it and it also promises that it will protect the property from getting damaged and that it will not use it unfairly.`}
        </td>
      </tr>
      <tr style={{ background: `${bg_color}` }}>
        <td>9</td>
        <td style={styles}>
          {lang === "krd"
            ? `له بەروارى واژوو كردنى ئەم گرێبەستە خزمەتگوزاريەكانى پرۆژە و شارەوانى و كارەبا و ئاو وهەر خزمەت گوزاريەكى تر هەبيت له ئەستۆى لايەنى دووەم دەبيت`
            : lang === "arb"
            ? `من تاريخ توقيع العقد يكون الطرف الثاني هو المسؤول عن دفع تكاليف الماء والكهرباء والبلدية وأية خدمة أخرى. `
            : `From the date of signing this contract all the expenses of the project, municipality, electricity, water and any other services will be the liability of the second party`}
        </td>
      </tr>
      <tr>
        <td>10</td>
        <td style={styles}>
          {lang === "krd"
            ? `لایەنی دووەم پابەند دەبێ بە پێدانی کرێ لە کاتی دیاریکراو لەم گرێبەستە. لەکاتی دواکەوتن لە (7) رۆژ زیاتر ئەوە بە پێی برگەی (1) لە ماددەی (17) لە یاسای بەکرێدانی مۆڵک لە قانونی عێراقی ژمارە (87) ساڵی (1979) مامەڵەی لەگەل دەکرێ ئەویش بە چۆڵ کردنی موڵکەکە و تێچوی هۆشداری دادگا ئەکەوێتە ئەستۆی لایەنی دووەم لەگەل کرێی مانگانە.`
            : lang === "arb"
            ? `يتعهد الطرف الثاني بدفع الأجرة في الوقت المحدد في العقد. وإذا تأخر أكثر من (7) أيام فيتعامل معه حسب الفقرة (1) من المادة (17) من قانون تأجير العقار من القانون العراقي المرقم (87) لسنة (1979) وهي تخلية العقار مع تحمل تكاليف تبليغ المحكمة مع الأجرة الشهرية. `
            : `The second party will be committed to paying the lease fee at the specified time stated in this contract. And in the case of getting delayed for more than (7) days, then the second party will be dealt with according to the Clause (1) from article (17) in the law for leasing the properties of the Iraqi Law number (87) in the year (1979) which is evacuating the property and the expenses for the court notice plus the monthly lease fee will be the liability of the second party.`}
        </td>
      </tr>
      <tr style={{ background: `${bg_color}` }}>
        <td>11</td>
        <td style={styles}>
          {lang === "krd"
            ? `ئەگەر شوێنى بەكرێگيراو راخراو بوو (مؤثث)لايەنى دووەم پێويستە پاريزگارى لە كەل و پەلەكان بكات و لەكاتى چۆل كردنى شوينى بەكرێگيراو وەك خۆى رادەستى لايەنى يەكەم بكاتەوە. بە پێچەوانەوە لايەنی دووەم بەرپرسە له چاككردنەوە يان گۆڕينى لەسەر ئەركى خۆى`
            : lang === "arb"
            ? `إذا كان العقار المؤجًّر مؤثثا على الطرف الثاني الحفاظ على الأثاث وعند التخلية يسلّمها كما كانت؛ خلافاً لذلك يكون الطرف الثاني مسؤولاً عن التصليح أو تبديله على مسؤوليته.`
            : `If the leased property was furnished, the second party should protect this stuff when evacuating the property, it should deliver to the first party as it was when being received. Otherwise, the second party will be responsible for repairing or changing the stuff on its own expense`}
        </td>
      </tr>
    </>
  );
};

export const DynamicArticle_MainForm = ({ bg_color, styles }) => {
  const dispatch = useDispatch();

  const name_krd = useSelector((state) => state.HelperReducer.name_krd);
  const name_en = useSelector((state) => state.HelperReducer.name_en);
  const name_arb = useSelector((state) => state.HelperReducer.name_arb);
  const lang = useSelector((state) => state.HelperReducer.lang);
  return (
    <>
      <tr>
        <td>12</td>
        <td style={styles}>{dispatch(change_Lang("balav_23"))}.</td>
      </tr>
      <tr style={{ background: `${bg_color}` }}>
        <td>13</td>
        <td style={styles}>
          {lang === "krd"
            ? `هەر یەک لە لایەنی یەکەم و لایەنی دووەم پێوستە بڕی کرێی نیو مانگ بۆ هەر ساڵێک بدەن بە ${name_krd} لە بڕی رێکخستنی ئەم گرێبەستە.`
            : lang === "arb"
            ? `على الطرفين دفع نصف مبلغ الأجرة سنوياً إلى ${name_arb} بدل تظيم هذا العقد`
            : `Each one of the first and the second party should pay half a month lease fee to ${name_en} for arranging this contract.`}
        </td>
      </tr>
      <tr>
        <td>14</td>
        <td style={styles}>{dispatch(change_Lang("balav_29"))}.</td>
      </tr>
      <tr style={{ background: `${bg_color}` }}>
        <td>15</td>
        <td style={styles}>
          {lang === "krd"
            ? `لەکاتی نوێ کردنەوەی گرێبەست هەر لایەنێک پابەند دەبێت بە پێدانی کرێی نیو مانگ بۆ یەک ساڵ بە ${name_krd}.`
            : lang === "arb"
            ? `يتعهد الطرفان عند تجديد العقد بدفع نصف مبلغ الأجرة سنوياً إلى ${name_arb}.`
            : `When renewing the contract each party will be committed to paying the amount of the lease fee for half a month to ${name_en} for each year.`}
        </td>
      </tr>
      <tr>
        <td>16</td>
        <td style={styles}>{dispatch(change_Lang("balav_32"))}.</td>
      </tr>
      <tr style={{ background: `${bg_color}` }}>
        <td>17</td>
        <td style={styles}>
          {lang === "krd"
            ? `لەکاتی چارەسەر نەبوونی کێشەی لایەنی یەکەم و دووەم بە شێوازی گفتوگۆ و دانوستاندن ئەوا ${name_krd} بەرپرس نیە و نابێت بەڵکو پێویستە لەسەر لایەنەکان کێشەکە چارەسەر بکەن بەگرتنەبەری رێکاری یاسایی و پەنابردن بۆ دادگای تایبەت.`
            : lang === "arb"
            ? `عند عدم حسم المشاكل بالحوار فيما بين الطرفين لا تتحمل ${name_arb} المسؤولية بل على الطرفين أن يحسم القضايا من خلال إجراءات قانونية واللجوء إلى محكمة خاصة. `
            : `In case of inability to solve the problem of the first and second parties through negotiations then ${name_en} is not responsible and will not be responsible but the parties should solve the problem through legal proceedings and to go to a specialized court.`}
        </td>
      </tr>
      <tr>
        <td>18</td>
        <td style={styles}>
          {lang === "krd" ? (
            <>
              {name_krd} بەرپرس نییە لە بوونی هەر کێشەیەک کە لەنێوان خاوەن مولک
              و کرێچی دا رووبدات .
            </>
          ) : lang === "arb" ? (
            <>
              {name_arb} غير مسؤول عن أي مشاكل أن يحدث بين مالك العقار
              والمستأجر.
            </>
          ) : (
            <>
              {name_en} is not responsible for any problems that occur between
              the two sides.
            </>
          )}
        </td>
      </tr>
    </>
  );
};
